var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ico"},[_c('div',[_c('span',{style:({backgroundImage: `url(${_vm.item.url})`})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }